<template>
  <div class="room-product">
    <div class="rp-title">
      <Row>
        <Col span="12" class="rp-txt">
        角色设置
        </Col>
        <Col span="12" class="f-tar">
        <Tooltip max-width="200" placement="top" :transfer="true" v-if="showAddGuest">
          <Button type="primary" @click.native="showGuestAdd">添加嘉宾</Button>
          <div slot="content">嘉宾：讲师和嘉宾可同时讲一堂课，支持连麦互动，需要使用最新开播端登录</div>
        </Tooltip>
        <Tooltip max-width="200" placement="top" :transfer="true">
          <Button type="primary" @click.native="showAssistantAdd">添加助教</Button>
          <div slot="content">
            助教：使用子频道登录助教管理后台，能够观看直播、参与互动、进行聊天室管理，发送图文直播，监控直播等操作
          </div>
        </Tooltip>
        </Col>
      </Row>
    </div>
    <div class="rp-content">
      <Table :columns="columns" :data="accList" :disabled-hover="false" no-data-text="暂无数据">
        <template slot-scope="{ row, index }" slot="avatar">
          <img style="height: 28px;height:28px;" :src="row.avatar" />
        </template>
        <template slot-scope="{ row, index }" slot="role">{{ roleArr[row.role] }}</template>
        <template slot-scope="{ row, index }" slot="actor">{{ row.actor }}</template>
        <template slot-scope="{ row, index }" slot="nickname">{{ row.nickname }}</template>
        <template slot-scope="{ row, index }" slot="account">
          <span v-if="row.role !== 'Teacher'">{{ row.account }}</span>
          <span v-else>{{ channelId }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="passwd">{{ row.passwd }}</template>
        <template slot-scope="{ row, index }" slot="roleList">
          <span v-if="row.role === 'Teacher'">登录后台、开播端登录、连麦</span>
          <span v-else-if="row.role === 'Guest'">开播端登录、连麦、禁言时可发言</span>
          <span v-else>{{ row.roleList }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="copyLiveUrl(row)">复制链接</span>
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="editShowAssistant(row)" v-if="row.role === 'Assistant'">编辑</span>
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="editShowGuest(row)" v-if="row.role === 'Guest'">编辑</span>
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="editShowTeacher(row)" v-if="row.role === 'Teacher'">编辑主讲</span>
          <Poptip confirm title="确认是否删除?" :transfer="true" @on-ok="delItem(row)" v-if="row.role !== 'Teacher'">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
      <div class="u-tip">
        <Icon type="ios-information-circle-outline" />
        <div>
          讲师：唯一角色，一个直播间只有1个讲师，负责上课和管理直播间信息
          <br />
          助教：使用子频道登录助教管理后台，能够观看直播、参与互动、进行聊天室管理，发送图文直播，监控直播等操作
          <br />
          嘉宾：讲师和嘉宾可同时讲一堂课，支持连麦互动，需要使用最新开播端登录
          <br />
        </div>
      </div>
    </div>
    <addAssistant :show="showAssistant" @finish="init()" @close="showAssistant = false; options = {};" :options="options" :modelTitle="modelTitle" />
    <addGuest :show="showGuest" @finish="init()" @close="showGuest = false; options2 = {};" :options="options2" :modelTitle="modelTitle2" />
    <editTeacher :show="showTeacher" @finish="init()" @close="showTeacher = false; options3 = {};" :options="options3" :modelTitle="modelTitle3" />
  </div>
</template>

<script>
import addAssistant from "./add-assistant.vue"; // 添加/编辑助教
import addGuest from "./add-guest.vue"; // 添加/编辑助教
import editTeacher from "./edit-teacher.vue"; // 编辑主讲

import { mapGetters, mapActions } from "vuex";
export default {
  name: "role-add",
  components: {
    addAssistant,
    addGuest,
    editTeacher,
  },
  props: {},
  data () {
    return {
      guestCount: 0, // 列表中贵宾的总数
      modelTitle: "添加助教",
      modelTitle2: "添加嘉宾",
      modelTitle3: "编辑主讲",
      showAssistant: false,
      showGuest: false,
      showTeacher: false,
      roleArr: {
        Assistant: "助教",
        Guest: "嘉宾",
        Teacher: "主讲",
      },
      columns: [
        {
          title: "头像",
          slot: "avatar",
          key: "avatar",
          align: "center",
          width: "70",
        },
        {
          title: "角色",
          slot: "role",
          key: "role",
          align: "center",
        },
        {
          title: "头衔",
          slot: "actor",
          key: "actor",
          align: "center",
        },
        {
          title: "昵称",
          slot: "nickname",
          key: "nickname",
          align: "center",
        },
        {
          title: "账号",
          slot: "account",
          key: "account",
          align: "center",
        },
        {
          title: "密码",
          slot: "passwd",
          key: "passwd",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      accList: [],
      options: {},
      options2: {},
      options3: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters({
      channel: "liveModule/getChannel",
    }),
    channelId () {
      return this.$route.query.channelId;
    },
    activityId () {
      return this.$route.query.activityId;
    },
    option () {
      return {
        activityId: this.activityId,
        page: 1,
        size: 1000
      }
    },
    showAddGuest () {
      let bool = false;
      if (this.channel && this.channel.linkMicLimit) {
        bool = true;
        if (this.guestCount && this.guestCount >= this.channel.linkMicLimit) {
          bool = false;
        }
      }
      return bool
    }
  },
  methods: {
    ...mapActions({
      allByActivityId: 'liveModule/allByActivityId',
      deleteMember: 'liveModule/deleteMember',
    }),
    async init () {
      this.guestCount = 0;
      if (!this.channelId) return;
      let res = await this.allByActivityId(this.option);
      console.log('allByActivityId', res);
      if (res && res.items) {
        res.items.map(c => {
          let arr = [];
          if (c.chatListEnabled === "Y") {
            arr.push("在线列表");
          }
          if (c.pageTurnEnabled === "Y") {
            arr.push("翻页");
          }
          if (c.monitorEnabled === "Y") {
            arr.push("监播");
          }
          if (c.chatAuditEnabled === "Y") {
            arr.push("聊天审核");
          }
          c.roleList = arr.join("、");
          if (c.role == 'Guest') {
            this.guestCount += 1;
          }
        });
        console.log('this.guestCount', this.guestCount);
        this.accList = res.items;
      }
    },
    showAssistantAdd () {
      // 新增助教
      this.showAssistant = true;
      this.modelTitle = "添加助教";
      this.options = {
        model: null,
        msg: null,
      };
    },
    editShowAssistant (item) {
      // 编辑助教
      this.showAssistant = true;
      this.modelTitle = "编辑助教";
      this.options = {
        model: "edit",
        msg: item,
      };
    },
    showGuestAdd () {
      // 新增嘉宾
      this.showGuest = true;
      this.modelTitle2 = "添加嘉宾";
      this.options2 = {
        model: null,
        msg: null,
      };
    },
    editShowGuest (item) {
      // 编辑嘉宾
      this.showGuest = true;
      this.modelTitle2 = "编辑嘉宾";
      this.options2 = {
        model: "edit",
        msg: item,
      };
    },
    editShowTeacher (item) {
      // 编辑嘉宾
      this.showTeacher = true;
      this.modelTitle3 = "编辑讲师";
      this.options3 = {
        model: "edit",
        msg: item,
      };
    },
    async delItem (item) {
      let opt = {
        id: item.id,
        request: {
          channelId: this.channelId,
          accounts: [item.account]
        }
      }
      let result = await this.deleteMember(opt);
      if (result) {
        this.$Message.success("删除成功");
        setTimeout(C => {
          this.init();
        }, 1000);
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    copyLiveUrl (item) {
      let url = '';
      if (item.role == 'Teacher') {
        url = `https://live.polyv.net/web-start/login?channelId=${this.channelId}`;
      } else if (item.role == 'Guest') {
        url = `https://live.polyv.net/web-start/guest?channelId=${item.account}`;
      } else if (item.role == 'Assistant') {
        url = `https://console.polyv.net/live/login.html?channelId=${item.account}`;
      }
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
      document.body.removeChild(input);
    },
  },
  created () {
    this.init();
  },
  mounted () { },
};
</script>

<style lang="scss" scoped>
.room-product {
  background: #fff;
  padding: 20px;
  min-height: 571px;

  .rp {
    &-txt {
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }

    &-title {
      /deep/ .ivu-btn {
        display: inline-block;
        margin-right: 20px;
      }
    }

    &-content {
      margin-top: 20px;
    }
  }
}
</style>
